module.exports = __webpack_public_path__ + "static/q2_o-27b414dea3765eb8f5755380658bb9b2.png";